/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiGmwGeojsonList200ResponseFeaturesInner } from "./ApiGmwGeojsonList200ResponseFeaturesInner";
import {
  ApiGmwGeojsonList200ResponseFeaturesInnerFromJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerFromJSONTyped,
  ApiGmwGeojsonList200ResponseFeaturesInnerToJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerToJSONTyped,
} from "./ApiGmwGeojsonList200ResponseFeaturesInner";

/**
 *
 * @export
 * @interface ApiGmwGeojsonList200Response
 */
export interface ApiGmwGeojsonList200Response {
  /**
   * GeoJSON type
   * @type {ApiGmwGeojsonList200ResponseTypeEnum}
   * @memberof ApiGmwGeojsonList200Response
   */
  type: ApiGmwGeojsonList200ResponseTypeEnum;
  /**
   * Number of features
   * @type {number}
   * @memberof ApiGmwGeojsonList200Response
   */
  count: number;
  /**
   * Array of GeoJSON Features
   * @type {Array<ApiGmwGeojsonList200ResponseFeaturesInner>}
   * @memberof ApiGmwGeojsonList200Response
   */
  features: Array<ApiGmwGeojsonList200ResponseFeaturesInner>;
}

/**
 * @export
 */
export const ApiGmwGeojsonList200ResponseTypeEnum = {
  FeatureCollection: "FeatureCollection",
} as const;
export type ApiGmwGeojsonList200ResponseTypeEnum =
  (typeof ApiGmwGeojsonList200ResponseTypeEnum)[keyof typeof ApiGmwGeojsonList200ResponseTypeEnum];

/**
 * Check if a given object implements the ApiGmwGeojsonList200Response interface.
 */
export function instanceOfApiGmwGeojsonList200Response(
  value: object
): value is ApiGmwGeojsonList200Response {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (value["type"] !== "FeatureCollection") return false;

  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("features" in value) || value["features"] === undefined) return false;
  return true;
}

export function ApiGmwGeojsonList200ResponseFromJSON(json: any): ApiGmwGeojsonList200Response {
  return ApiGmwGeojsonList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGeojsonList200Response {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    count: json["count"],
    features: (json["features"] as Array<any>).map(
      ApiGmwGeojsonList200ResponseFeaturesInnerFromJSON
    ),
  };
}

export function ApiGmwGeojsonList200ResponseToJSON(json: any): ApiGmwGeojsonList200Response {
  return ApiGmwGeojsonList200ResponseToJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseToJSONTyped(
  value?: ApiGmwGeojsonList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    count: value["count"],
    features: (value["features"] as Array<any>).map(
      ApiGmwGeojsonList200ResponseFeaturesInnerToJSON
    ),
  };
}
